type FieldSource = 'document' | 'user' | 'trust-filie';

interface TrustFilieBadgeProps {
  source: FieldSource;
  documentType?: string;
}

export default function TrustFilieBadge({ source, documentType }: TrustFilieBadgeProps) {
  if (source === 'document') {
    const label = documentType ? `From ${documentType}` : 'From documents';
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-50 text-blue-700">
        {label}
      </span>
    );
  }

  if (source === 'trust-filie') {
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-indigo-50 text-indigo-600">
        Trust Filie
      </span>
    );
  }

  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-500">
      You entered
    </span>
  );
}

export type { FieldSource };
